/* eslint-disable react-hooks/exhaustive-deps */
import { FC, useEffect, useState } from "react";
import clsx from "clsx";
import { Anchor, Media, MediaBody } from "@ht/components";
import dayjs from "dayjs";
import { useAppSelector } from "../../../app/hooks";

interface IProps {
    status?: "read" | "unread";
    senderName: string;
    message: string;
    messageType: string;
    messageTime: Date;
    onClick?: () => void;
}

const DropddownItem: FC<IProps> = ({
    status = "unread",
    senderName,
    message,
    messageType,
    messageTime,
    onClick,
}) => {
    const hoverClass =
        status === "unread" && "hover:bg-gray-200 focus:bg-gray-200";
    const readClass =
        status === "read" && "bg-gray-200 hover:bg-gray-300 hover:bg-gray-300";

    const { incomingRoom } = useAppSelector((state) => state.chatagent);
    const [fullName, setFullName] = useState("");

    useEffect(() => {
        const room = incomingRoom.find((a) => a.userName == senderName);
        if (room) setFullName(room.fullName);
    }, [incomingRoom]);

    const getMessage = () => {
        let result = message;
        if (messageType != "TEXT") {
            result = "Send a " + messageType.toLowerCase();
        }
        return result;
    };
    const getLatestMessageTime = (time: Date) => {
        let result = dayjs(time).format("MMM DD");
        const messageDate = dayjs(time).format("YYYY-MM-DD");
        const dateNow = dayjs().format("YYYY-MM-DD");
        const yesterday = dayjs().subtract(1, "day").format("YYYY-MM-DD");

        if (messageDate == dateNow) {
            result = dayjs(time).format("HH:mm");
        } else if (messageDate == yesterday) {
            result = "Yesterday";
        }

        return result;
    };
    return (
        <Anchor
            path="#"
            onClick={onClick}
            className={clsx(
                "block px-[0.938rem] py-[0.625rem] border-b border-b-geyser text-body",
                hoverClass,
                readClass
            )}
        >
            <Media>
                <MediaBody>
                    <div className="flex justify-between">
                        <div
                            className="mb-1 text-sm text-left overflow-hidden"
                            style={{ wordBreak: "break-word" }}
                        >
                            <strong className="font-semibold text-[13px] text-heading">
                                {fullName}
                            </strong>
                        </div>

                        <span className="text-pale block text-sm text-right font-semibold">
                            {getLatestMessageTime(messageTime)}
                        </span>
                    </div>
                    <div
                        className="mb-1 text-base text-left overflow-hidden max-h-10"
                        style={{ wordBreak: "break-word" }}
                    >
                        {getMessage()}
                    </div>
                </MediaBody>
            </Media>
        </Anchor>
    );
};

export default DropddownItem;
